export const checksums = {
  "employees": "v3.5.0--yw23Wd6lB62NCJ-ciLx-TlZrKOb4bGK1bc-ALeDy1Mo",
  "vacancies": "v3.5.0--VVIbNkJOYhjv_qwWr3Lb3YyzOwTGNRbAKNGmtjfrMq0",
  "content": "v3.5.0--cbtb2S-8DOQcUyPfBqv2ihcgfwbZ_WRPpxe4OV9c5Rk",
  "therapyServices": "v3.5.0--o2yn-SEFdtZ11SR_RcaRdoWYhFK8pU4jK441xqHAe78"
}
export const checksumsStructure = {
  "employees": "5NMQlXQmVn_eyd17bQA87dssHjJtFDnXDW6ELjZ0Dlg",
  "vacancies": "RUs0SUKbAzoV-siIHNMYdH6hPp6gzDu4oIZC6uFLaZQ",
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "therapyServices": "ElDmJIH_hoWD5_nmqecEB2YSG-_RNQICt6Oix1cmrf8"
}

export const tables = {
  "employees": "_content_employees",
  "vacancies": "_content_vacancies",
  "content": "_content_content",
  "therapyServices": "_content_therapyServices",
  "info": "_content_info"
}

export default {
  "employees": {
    "type": "data",
    "fields": {
      "id": "string",
      "description": "string",
      "extension": "string",
      "firstName": "string",
      "fullName": "string",
      "image": "string",
      "jobFunction": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "vacancies": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "additionalSkillset": "json",
      "body": "json",
      "description": "string",
      "employmentType": "string",
      "extension": "string",
      "hours": "json",
      "level": "string",
      "location": "string",
      "meta": "json",
      "navigation": "json",
      "offer": "json",
      "organization": "string",
      "path": "string",
      "postingDate": "date",
      "salary": "json",
      "seo": "json",
      "shortDescription": "string",
      "skillset": "json",
      "startDate": "json",
      "stem": "string",
      "workHours": "string"
    }
  },
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "therapyServices": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "price": "number",
      "stem": "string",
      "url": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}